import React, {Fragment} from 'react';
import {useParams} from 'react-router';
import CardContainerForm from '../../components/CardContainerForm';
import Form from '../../components/forms/PlaceOfSale';

export default function RegularTables1(props) {
  const {id} = useParams();

  return (
    <>
      <CardContainerForm>
        <Form id={id} openAlert={props.openAlert} pms={props.pms} />
      </CardContainerForm>
    </>
  );
}
